'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _Icons = require('../../Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _NotificationBadge = require('./NotificationBadge');

var _NotificationBadge2 = _interopRequireDefault(_NotificationBadge);

var _urlLocations = require('../../../routes/urlLocations');

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _Menu = require('../../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _styled = require('../styled');

var _styled2 = _interopRequireDefault(_styled);

var _IsUser = require('../../../utils/user/IsUser');

var _IsUser2 = _interopRequireDefault(_IsUser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AuthorizedMenu = function AuthorizedMenu(props) {
  var setLogoutModalVisible = props.setLogoutModalVisible,
      _props$user = props.user,
      givenName = _props$user.givenName,
      familyName = _props$user.familyName,
      userType = _props$user.userType,
      unread = props.unread,
      isAdminPlatform = props.isAdminPlatform,
      accentColor = props.accentColor;
  var isUser = new _IsUser2.default(userType);
  var isSp = isUser.allSP;
  var Menu = (0, _Menu2.default)({
    place: _place2.default.Header
  });
  var iconStyles = {
    color: isSp ? '#1A1A1A' : '#B5C3CA'
  };

  var signOut = function signOut(e) {
    e.preventDefault();
    setLogoutModalVisible(true);
  };

  var profileUrl = isAdminPlatform ? _urlLocations.adminUserProfile : _urlLocations.userProfile;
  return _react2.default.createElement(Menu.Wrapper, null, _react2.default.createElement(Menu.List, null, _react2.default.createElement(Menu.Item, {
    key: 'notifications',
    isSp: isSp
  }, _react2.default.createElement(Menu.NavLink, {
    to: _urlLocations.notifications
  }, _react2.default.createElement(_NotificationBadge2.default, {
    count: unread,
    iconStyles: iconStyles
  }))), _react2.default.createElement(Menu.SubMenu, {
    isSp: isSp,
    accentColor: accentColor,
    key: 'profileSubMenu',
    title: _react2.default.createElement(_react2.default.Fragment, null, givenName ? _react2.default.createElement(_styled2.default.UserCircle, {
      isSp: isSp,
      accentColor: accentColor
    }, givenName.charAt(0).toUpperCase()) : _react2.default.createElement('div', null, _react2.default.createElement(_Icons2.default.user, {
      style: iconStyles
    }), _react2.default.createElement(_Icons2.default.Fa, {
      rotate: '270',
      style: iconStyles,
      name: 'angle-down'
    })))
  }, _react2.default.createElement('div', {
    style: {
      marginTop: '18px'
    }
  }, _react2.default.createElement(Menu.Item, {
    key: 'profile'
  }, _react2.default.createElement(Menu.NavLink, {
    to: profileUrl
  }, _react2.default.createElement(_Icons2.default.user, {
    style: iconStyles
  }), _react2.default.createElement('span', {
    style: iconStyles
  }, 'Profile'))), _react2.default.createElement(Menu.Item, {
    key: 'logout'
  }, _react2.default.createElement(Menu.NavLink, {
    to: '#',
    onClick: function onClick(e) {
      return signOut(e);
    }
  }, _react2.default.createElement(_Icons2.default.logOut, {
    style: iconStyles
  }), _react2.default.createElement('span', {
    style: iconStyles
  }, 'Sign out')))))));
};

AuthorizedMenu.defaultProps = {
  pathname: '',
  unread: null,
  userTheme: null
};
AuthorizedMenu.propTypes = {
  isAdminPlatform: _propTypes2.default.bool.isRequired,
  pathname: _propTypes2.default.string,
  setLogoutModalVisible: _propTypes2.default.func.isRequired,
  unread: _propTypes2.default.number,
  user: _propTypes2.default.shape({
    givenName: _propTypes2.default.string.isRequired,
    familyName: _propTypes2.default.string.isRequired
  }).isRequired,
  userTheme: _propTypes2.default.string
};
exports.default = (0, _styledComponents.withTheme)(AuthorizedMenu);